import { useState } from "react";
import ContentManager from "../ContentManager";

const TABS = [
  ["capability_section", "Page Sections"],
  ["capability_card", "Home Cards"],
  ["scale_group", "Engineering Scale"],
];

const CapabilitiesAdmin = () => {
  const [tab, setTab] = useState(TABS[0][0]);
  return (
    <div>
      <div className="mb-6 flex gap-2 flex-wrap" data-testid="cap-admin-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`cap-tab-${k}`}
            className={`px-4 py-2 text-[11px] font-display font-semibold uppercase tracking-widest border transition-colors ${tab === k ? "bg-[#0A1128] text-white border-[#0A1128]" : "bg-white text-slate-600 border-slate-300 hover:border-slate-500"}`}>
            {l}
          </button>
        ))}
      </div>
      {tab === "capability_section" && (
        <ContentManager type="capability_section" title="Capabilities Page Sections"
          description="The five engineering capability blocks on the public Capabilities page." />
      )}
      {tab === "capability_card" && (
        <ContentManager type="capability_card" title="Home Capability Cards"
          description="The capability cards shown on the homepage." />
      )}
      {tab === "scale_group" && (
        <ContentManager type="scale_group" title="Engineering Scale Groups"
          description="The verified capability figures shown on Home, Capabilities and Facilities." />
      )}
    </div>
  );
};

export default CapabilitiesAdmin;
